/* original source: https://ui.shadcn.com/docs/components/radio-group */

import * as React from 'react'
import { RadioGroup as RadioGroupPrimitive } from 'radix-ui'
import { cn } from '@joyful/utils'

export function RadioGroup({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  )
}

export function RadioGroupRawIndicator({
  className,
  isSelected,
  ...restProps
}: React.ComponentProps<'span'> & { isSelected: boolean }) {
  return (
    <span
      className={cn(
        'bg-tremor-background flex aspect-square size-4 shrink-0 items-center justify-center rounded-full border outline-hidden',
        className,
      )}
      {...restProps}
    >
      <span
        className={cn(
          'bg-tremor-brand size-2 rounded-full transition-opacity',
          isSelected ? 'opacity-100' : 'opacity-0',
        )}
      />
    </span>
  )
}

export function RadioGroupItem({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Item>) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'border-tremor-border bg-tremor-background focus-visible:border-tremor-ring focus-visible:ring-tremor-ring/50 aspect-square size-4 shrink-0 rounded-full border shadow-xs outline-hidden transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-red-500 aria-invalid:ring-red-500/20',
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator
        data-slot="radio-group-indicator"
        className="relative flex items-center justify-center"
      >
        <span className="bg-tremor-brand absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
}
